import 'sticky-sidebar/dist/jquery.sticky-sidebar.js';

var stickySidebar;

function mobileOnlySlider($slidername, $dots, $arrows, $breakpoint) {
  var slider = $($slidername);
  var settings = {
    mobileFirst: true,
    dots: $dots,
    arrows: $arrows,
    responsive: [
      {
        breakpoint: $breakpoint,
        settings: "unslick"
      }
    ]
  };

  slider.slick(settings);

  $(window).on("resize", function () {
    if ($(window).width() > $breakpoint) {
      return;
    }
    if (!slider.hasClass("slick-initialized")) {
      return slider.slick(settings);
    }
  });
}

$(document).on('ready', function() {


  /* prepare image */
  if($('.product-single__images-group-wrapper').length) {
    var firstActiveSku = $('.product-single__variants.no-js option[selected="selected"]').attr('data-sku');
    if(firstActiveSku) {
      $('.product-single__images-group .product-single__images--wrapper').hide();
      var variantImages = $('.product-single__images-group').find('.product-single__images--wrapper[data-sku="' + firstActiveSku + '"]');
      var arrow = $('<div class="pdp_icon-down"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19 9L12 16L5 9" stroke="#292017" stroke-linecap="round" stroke-linejoin="round"></path></svg></div>');
     
      if(variantImages.length) {
        $('.product-single__images-group .product-single__images--wrapper').removeClass('first-image');
        $('.product-single__images-group').find('.pdp_icon-down').remove();
        variantImages.eq(0).addClass('first-image');
        variantImages.eq(0).find('.product-single__media-wrapper').addClass('first-image');
        variantImages.eq(0).find('.product-single__media-wrapper').prepend(arrow);
      }
      for(var i = 0; i <= variantImages.length; i++) {
        if(((variantImages.length == 3 || variantImages.length == 4 || variantImages.length == 5) && (i == 1 || i == 2)) || ((variantImages.length == 6 || variantImages.length == 7 || variantImages.length == 8) && (i == 1 || i == 2 || i == 4 || i == 5))) {
          variantImages.eq(i).addClass('product-single__images--wrapper--two-column');
        }

        var image = variantImages.eq(i).clone();

        $('.variant-image-wrapper').append(image);
      }

      if(screen.width < 768) {
        mobileOnlySlider(".variant-image-wrapper", false, true, 767);
      }
     
      variantImages.show();
    }

    setTimeout(function() {
      if ($(window).width() > 960) {
        stickySidebar = new StickySidebar('#sidebar', {
          topSpacing: 100,
          bottomSpacing: -200,
          innerWrapperSelector: '.sidebar__inner',
          stickyClass: 'is-affixed',
          containerSelector: '.product-single__media--wrapper'
        });
      };
      $('.product-single__images-group-wrapper').css("visibility", "visible");
    }, 1000);
  }

  /* end prepare image */

  /* view available variant only  */

  if($('.product-single__variants.no-js').length > 0 && $('label[for="ProductSelect-option-1"]').length > 0 && $('.product-single__variants.no-js option').attr('data-option-1') != "" && $('.product-single__variants.no-js option').attr('data-option-2') != "") {
    $('.product-form__item .variants-item').css('opacity', '0.2');
    $('.product-form__item .fake-select .options-wrapper div').css('opacity', '0.2');

    var option_1 = $('.product-single__variants.no-js option[selected="selected"]').attr('data-option-1');
    var option_2 = $('.product-single__variants.no-js option[selected="selected"]').attr('data-option-2');

    $('.product-single__variants.no-js option').each(function(index) {
      if($(this).attr('data-option-1') == option_1 || $(this).attr('data-option-2') == option_2) {
        var option_1_to_view = $(this).attr('data-option-1');
        var option_2_to_view = $(this).attr('data-option-2');

        if($('.product-form__item .variants-item .circle-rel-color[data-value="' + option_1_to_view + '"]').length) {
          $('.product-form__item .variants-item .circle-rel-color[data-value="' + option_1_to_view + '"]').parents('.variants-item').css('opacity', '1');
        }

        if($('.product-form__item .fake-select .options-wrapper div[data-value="' + option_1_to_view + '"]').length) {
          $('.product-form__item .fake-select .options-wrapper div[data-value="' + option_1_to_view + '"]').css('opacity', '1');
        }
        if($('.product-form__item .fake-select .options-wrapper div[data-value="' + option_2_to_view + '"]').length) {
          $('.product-form__item .fake-select .options-wrapper div[data-value="' + option_2_to_view + '"]').css('opacity', '1');
        }
      }
    });
  }

  /* end view available variant only  */

  $('.radio-wrapper .variants-wrapper .circle-rel-color').on('click', function() {
    $('.radio-wrapper .variants-wrapper .circle-rel-color').removeClass('selected');
    $(this).addClass('selected');
    var value = $(this).attr('data-value');
    $(this).parents('.radio-wrapper').find('.product-single__label strong').html(value);
    $(this).parents('.variants-wrapper').siblings('.select-color').find('.product-form__input').val(value).change();
  });

  $('.fake-select .selected-option').on('click', function() {
    $(this).parents('.fake-select').toggleClass('open-select');
  });

  $('.fake-select').on('click', '.options-wrapper div', function(e) {
    e.preventDefault();
    e.stopPropagation();

	var inStockInfo = $(".product-single__stock-info.in-stock"),
	outOfStockInfo = $(".product-single__stock-info.out-of-stock");

    $(this).parents('.fake-select').removeClass('open-select');
    $(this).parents('.fake-select').find('.options-wrapper div').removeClass('selected');
    $(this).addClass('selected');

    //Select the size in the real select
    var fakeVariantValue = $(this).attr('data-value');
    $(this).parents('.fake-select').find('.selected-option span').html(fakeVariantValue);
    $(this).parents('.fake-select').siblings('.product-form__input').val(fakeVariantValue).change();

	if ($(e.target).hasClass("available")) {
	  if (inStockInfo.length && inStockInfo.hasClass("hidden")) {
		inStockInfo.removeClass("hidden");	
	  };
	  if (outOfStockInfo.length && !outOfStockInfo.hasClass("hidden")) {
		outOfStockInfo.addClass("hidden");	
	  };
	} else {
	  if (outOfStockInfo.length && outOfStockInfo.hasClass("hidden")) {
		outOfStockInfo.removeClass("hidden");	
	  };
	  if (inStockInfo.length && !inStockInfo.hasClass("hidden")) {
		inStockInfo.addClass("hidden");	
	  };
	}
  });

  $('.template-product__section').on('variantChange', function(e) {
      $('.product-single__images-group-wrapper').css("visibility", "hidden");
      if(e.variant) {
        var activeSku = e.variant.sku;
        if(activeSku) {
          $('.product-single__images-group .product-single__images--wrapper').hide();
          $('.variant-image-wrapper').removeClass('slick-initialized').removeClass('slick-slider').empty();
          var variantImages = $('.product-single__images-group').find('.product-single__images--wrapper[data-sku="' + activeSku + '"]');
          var arrow = $('<div class="pdp_icon-down"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19 9L12 16L5 9" stroke="#292017" stroke-linecap="round" stroke-linejoin="round"></path></svg></div>');

          if(variantImages.length) {
            $('.product-single__images-group .product-single__images--wrapper').removeClass('first-image');
            $('.product-single__images-group').find('.pdp_icon-down').remove();
            variantImages.eq(0).addClass('first-image');
            variantImages.eq(0).find('.product-single__media-wrapper').addClass('first-image');
            variantImages.eq(0).find('.product-single__media-wrapper').prepend(arrow);
          }

          for(var i = 0; i <= variantImages.length; i++) {
            if(((variantImages.length == 3 || variantImages.length == 4 || variantImages.length == 5) && (i == 1 || i == 2)) || ((variantImages.length == 6 || variantImages.length == 7 || variantImages.length == 8) && (i == 1 || i == 2 || i == 4 || i == 5))) {
              variantImages.eq(i).addClass('product-single__images--wrapper--two-column');
            }

            var image = variantImages.eq(i).clone();

            $('.variant-image-wrapper').append(image);
          }

          if(screen.width < 768) {
            mobileOnlySlider(".variant-image-wrapper", false, true, 767);
          }
  
          variantImages.show();
        };
  
        if(stickySidebar) {
          stickySidebar.updateSticky();
        }

        $('.availabile-combination').css('display', 'none');
        $('#product-single__add-to-cart-inner button[type="submit"]').removeAttr('disabled');
      } else {
        $('.availabile-combination').html($('.availabile-combination').attr('data-message'));
        $('.availabile-combination').css('display', 'block');
        $('#product-single__add-to-cart-inner button[type="submit"]').attr('disabled', 'disabled');
      }

      setTimeout(function() {
        $('.product-single__images-group-wrapper').css("visibility", "visible");
      }, 1000);
    });


      /* view available variant only  */
      $('.product-form__item .fake-select .options-wrapper div, .product-form__item .variants-item .circle-rel-color').on('click', function(e) {
		var inStockInfo = $(".product-single__stock-info.in-stock"),
		outOfStockInfo = $(".product-single__stock-info.out-of-stock");

        if($('.product-single__variants.no-js').length > 0 && $('label[for="ProductSelect-option-1"]').length > 0 && $('.product-single__variants.no-js option').attr('data-option-1') != "" && $('.product-single__variants.no-js option').attr('data-option-2') != "") {
          $('.product-form__item .variants-item').css('opacity', '0.2');
          $('.product-form__item .fake-select .options-wrapper div').css('opacity', '0.2');

          var label_name = $(this).parents('.product-form__item').find('label').attr('for');
          if(label_name.indexOf('0') > 0) {
            var option_1 = $(this).attr('data-value');
            var option_2 = $('#SingleOptionSelector-1').siblings('.fake-select').find('.options-wrapper .selected').attr('data-value');
          } else if(label_name.indexOf('1') > 0) {
            var option_2 = $(this).attr('data-value');
            if ($('#SingleOptionSelector-0').siblings('.fake-select').length > 0) {
              var option_1 = $('#SingleOptionSelector-0').siblings('.fake-select').find('.options-wrapper .selected').attr('data-value');
            } else if($('.variants-wrapper .variants-item .circle-rel-color').length > 0) {
              var option_1 = $('.variants-wrapper .variants-item .circle-rel-color.selected').attr('data-value');
            }
          }

          $('.product-single__variants.no-js option').each(function(index) {
            if(option_1 != '') {
              if($(this).attr('data-option-1') == option_1) {
                var option_1_to_view = $(this).attr('data-option-1');
                var option_2_to_view = $(this).attr('data-option-2');
  
                if($('.product-form__item .variants-item .circle-rel-color[data-value="' + option_1_to_view + '"]').length) {
                  $('.product-form__item .variants-item .circle-rel-color[data-value="' + option_1_to_view + '"]').parents('.variants-item').css('opacity', '1');
                }
  
                if($('.product-form__item #SingleOptionSelector-0').siblings('.fake-select').find('.options-wrapper div[data-value="' + option_1_to_view + '"]').length) {
                  $('.product-form__item #SingleOptionSelector-0').siblings('.fake-select').find('.options-wrapper div[data-value="' + option_1_to_view + '"]').css('opacity', '1');
                }
  
                if($('.product-form__item #SingleOptionSelector-1').siblings('.fake-select').find('.options-wrapper div[data-value="' + option_2_to_view + '"]').length) {
                  $('.product-form__item #SingleOptionSelector-1').siblings('.fake-select').find('.options-wrapper div[data-value="' + option_2_to_view + '"]').css('opacity', '1');
                }
              }
            }

            if(option_2 != '') {
              if($(this).attr('data-option-2') == option_2) {
                var option_1_to_view = $(this).attr('data-option-1');
                var option_2_to_view = $(this).attr('data-option-2');
  
                if($('.product-form__item .variants-item .circle-rel-color[data-value="' + option_1_to_view + '"]').length) {
                  $('.product-form__item .variants-item .circle-rel-color[data-value="' + option_1_to_view + '"]').parents('.variants-item').css('opacity', '1');
                }
  
                if($('.product-form__item #SingleOptionSelector-0').siblings('.fake-select').find('.options-wrapper div[data-value="' + option_1_to_view + '"]').length) {
                  $('.product-form__item #SingleOptionSelector-0').siblings('.fake-select').find('.options-wrapper div[data-value="' + option_1_to_view + '"]').css('opacity', '1');
                }
  
                if($('.product-form__item #SingleOptionSelector-1').siblings('.fake-select').find('.options-wrapper div[data-value="' + option_2_to_view + '"]').length) {
                  $('.product-form__item #SingleOptionSelector-1').siblings('.fake-select').find('.options-wrapper div[data-value="' + option_2_to_view + '"]').css('opacity', '1');
                }
              }
            }
          });

		  if ($(e.target).hasClass("available")) {
			if (inStockInfo.length && inStockInfo.hasClass("hidden")) {
			  inStockInfo.removeClass("hidden");	
			};
			if (outOfStockInfo.length && !outOfStockInfo.hasClass("hidden")) {
			  outOfStockInfo.addClass("hidden");	
			};
		  } else {
			if (outOfStockInfo.length && outOfStockInfo.hasClass("hidden")) {
			  outOfStockInfo.removeClass("hidden");	
			};
			if (inStockInfo.length && !inStockInfo.hasClass("hidden")) {
			  inStockInfo.addClass("hidden");	
			};
		  }
        }
      });
      /* end view available variant only  */
});

